<template>
  <el-dialog
    :visible.sync="value.visible"
    :title="params.title"
    width="500px"
    destroy-on-close
    append-to-body
    :close-on-click-modal="params.canClose"
    :close-on-press-escape="params.canClose"
    :show-close="params.canClose"
    @opened="onOpened"
    @before-close="onBeforeClose"
  >
    <el-alert
      :title="params.msg"
      :type="params.msgType"
      :closable="false"
      show-icon
      effect="light"
      class="mb-6"
    />
    <el-form ref="dlgForm" label-position="top" label-width="120px" :model="user">

      <el-form-item>
        <el-input v-model.trim="user.mobile" placeholder="手机号" />
      </el-form-item>
      <el-form-item>
        <el-input v-model.trim="user.captcha" placeholder="验证码">
          <template #append>
            <el-button
              :loading="$store.state.app.loadingList.includes('sendVcode')"
              :disabled="captchaDisabled"
              style="width:120px;"
              @click="onGetCaptcha"
            >{{ captchaText }}</el-button>
          </template>
        </el-input>
      </el-form-item>

    </el-form>

    <template #footer>
      <div class="dialog-footer">
        <el-button v-show="params.canClose" @click="value.visible = false">取 消</el-button>
        <el-button type="primary" :loading="$store.state.app.loadingList.includes('chmobile')" @click="onOk">确 定</el-button>
      </div>
    </template>
  </el-dialog>

</template>

<script>
import { updateMe } from '@/api/user'
import { sendVcode } from '@/api/util'

export default {
  name: 'DlgSetMobile',
  components: {
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        visible: false
      })
    },
    params: {
      type: Object,
      default: () => ({
        title: '绑定手机',
        msg: '',
        msgType: 'info',
        canClose: true
      })
    }
  },
  emits: ['ok', 'cancel'],
  data() {
    return {
      captchaDisabled: false,
      captchaText: '获取验证码',
      user: {
        mobile: null,
        captcha: null
      }
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  mounted() {
    console.log(this.value)
  },

  methods: {
    async fetchUserInfo() {
      const that = this
      const res = await this.$store.dispatch('user/getUserInfo')
      that.user = res
    },
    onOpened() {
      const that = this
      that.captchaDisabled = false
      that.captchaText = '获取验证码'
      that.user.mobile = null
      that.user.captcha = null
    },
    onBeforeClose() {
      return false
    },
    async onOk() {
      const that = this
      await that.$refs.dlgForm.validate(async(valid, fields) => {
        if (valid) {
          const res = await updateMe({
            scen: 'chmobile',
            mobile: that.user.mobile,
            vcode: that.user.captcha
          }, 'chmobile')

          console.log(res)
          // ElMessage({
          //   message: "操作成功",
          //   type: "success",
          // });

          // eslint-disable-next-line require-atomic-updates
          that.value.visible = false
          // 更新数据
          await that.fetchUserInfo()
        } else {
          console.log('error submit!', fields)
        }
      })
    },
    async onGetCaptcha() {
      const that = this
      if (!that.user.mobile) return
      await sendVcode({ query: `?account=${that.user.mobile}&type=change_account` }, 'sendVcode')

      // eslint-disable-next-line require-atomic-updates
      that.captchaDisabled = true

      let secs = 60
      const timer = setInterval(() => {
        that.captchaText = `${secs}秒`

        if (--secs < 0) {
          clearInterval(timer)
          that.captchaDisabled = false
          that.captchaText = '获取验证码'
          return
        }
      }, 1000)
    },

    onCancel() {
      console.log('cancel')
      this.value.visible = false
      this.$emit('cancel')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped></style>
